import useWindowWidth from "components/reusable/useWindowWidth";
import AuthContext from "context/AuthContext";
import { useContext } from "react";
import DashboardDesktop from "./DashboardDesktop/DashboardDesktop";
import DashboardMobile from "./DashboardMobile";

function Dashboard() {
  let { user } = useContext(AuthContext);
  const width = useWindowWidth();

  if (!user) return <></>;

  const breakPoint = 767;
  return width <= breakPoint ? <DashboardMobile /> : <DashboardDesktop />;
}

export default Dashboard;
